import { memo } from 'react';

import { CopyText, Flex, Label, Link, Text } from '@/components/core';
import { useGetAppClientWithSecret } from '@/hooks';

export type TriggerN8NConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const ITriggerN8NConfiguration = ({}: TriggerN8NConfigurationProps = {}) => {
  const { data: appClient } = useGetAppClientWithSecret();

  return (
    <Flex col className="gap-md p-md grow">
      <Label>Credentials</Label>

      <Flex variant="plain" col className="p-md gap-4 rounded-lg border-1 border-gray-100 bg-white shadow-xs">
        <Flex col className="gap-xs">
          <Label>Client ID</Label>
          <CopyText value={appClient?.clientId} />
        </Flex>

        <Flex col className="gap-xs">
          <Label>Client Secret</Label>
          <CopyText isSensitive value={appClient?.clientSecret} />
        </Flex>
      </Flex>

      <Text>
        Read N8N documentation<span> </span>
        <Link href="https://docs.cradl.ai/integrations/n8n" className="font-regular text-sm">
          here.
        </Link>
      </Text>
    </Flex>
  );
};

export const TriggerN8NConfiguration = memo(ITriggerN8NConfiguration) as typeof ITriggerN8NConfiguration;
